import React, { useRef, useEffect, useState } from "react";
import "./SecondSection.css";

const SecondSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const currentSection = sectionRef.current;

    // Intersection Observer for animation trigger
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (currentSection) observer.observe(currentSection);

    return () => {
      if (currentSection) observer.unobserve(currentSection);
    };
  }, []);

 // ✅ Lazy load helper (trigger animation when visible in viewport)
const LazyImage = ({ src, alt, className }) => {
  const [loaded, setLoaded] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
  const currentWrapper = wrapperRef.current; // ✅ store it safely
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    });
  }, { threshold: 0.3 });

  if (currentWrapper) observer.observe(currentWrapper);

  return () => {
    if (currentWrapper) observer.unobserve(currentWrapper); // ✅ safe cleanup
  };
}, []);

  // Random animation direction
  const [direction] = useState(() => {
    const directions = ["from-left", "from-right", "from-bottom", "zoom-in"];
    return directions[Math.floor(Math.random() * directions.length)];
  });

  return (
    <div
      ref={wrapperRef}
      className={`lazy-image-wrapper ${direction} ${
        isVisible && loaded ? "show" : ""
      }`}
    >
      <img
        src={src}
        alt={alt}
        className={`${className} ${loaded ? "loaded" : ""}`}
        loading="lazy"
        onLoad={() => setLoaded(true)}
      />
      {!loaded && <div className="image-skeleton"></div>}
    </div>
  );
};
;


  return (
    <div
      className={`cad-section-container ${isVisible ? "visible" : ""}`}
      ref={sectionRef}
    >
      <div className="cad-box">
        {/* ✅ Top Icon */}
        <div className="cad-icon-wrapper">
          <img
            src={`${process.env.PUBLIC_URL}/assets/Module-Paradon.png`}
            alt="Paradon Module Icon"
            className="cad-icon-img"
          />
        </div>

        {/* ✅ Heading */}
        <h2>HEXAGON PPM SMART 3D / AVEVA EVERYTHING 3D Catalogs</h2>

        {/* ✅ Text Content */}
        <div className="cad-list-section">
          <ul>
            <li>
              Creates and delivers piping specification and catalogue data for use
              in 3D modelling environments such as Hexagon PPM Smart 3D and
              AVEVA Everything3D
            </li>
            <li>Create and edit categories</li>
            <li>Create cocotables</li>
            <li>Create component families (Gpart)</li>
            <li>Create and modify piping and nozzle specifications</li>
            <li>Create weight tables via propcon</li>
            <li>Ensure the validity of a catalog (3D and 2D)</li>
          </ul>
        </div>

        {/* ✅ Bottom Animated Images */}
        <div className="bottom-images">
          <LazyImage
            src={`${process.env.PUBLIC_URL}/assets/extra-image1.jpg`}
            alt="Smart 3D Piping Specification Example"
            className={`bottom-img bottom ${isVisible ? "visible" : ""}`}
          />
          <LazyImage
            src={`${process.env.PUBLIC_URL}/assets/extra-image2.jpg`}
            alt="AVEVA 3D Catalog Editing Example"
            className={`bottom-img zoom ${isVisible ? "visible" : ""}`}
          />
          <LazyImage
            src={`${process.env.PUBLIC_URL}/assets/right-image.png`}
            alt="Hexagon Smart 3D Sample View"
            className={`bottom-img left ${isVisible ? "visible" : ""}`}
          />
          <LazyImage
            src={`${process.env.PUBLIC_URL}/assets/left-image.png`}
            alt="AVEVA Everything3D Interface"
            className={`bottom-img right ${isVisible ? "visible" : ""}`}
          />
        </div>
      </div>
    </div>
  );
};

export default SecondSection;
